class Sale {
  constructor(element) {
    this.element = element;
    this.goldMobile = element.querySelector('[js-sale-gold-mobile]');
    this.goldDesktop = element.querySelector('[js-sale-gold-desktop]');
    this.silverMobile = element.querySelector('[js-sale-silver-mobile]');
    this.silverDesktop = element.querySelector('[js-sale-silver-desktop]');

    this.init()
  }

  init() {
    this.getPrices();
  }

  setLabels(gold, silver) {
    if (this.goldMobile && this.goldDesktop) {
      this.goldMobile.innerHTML = `Nog ${gold}g!`;
      this.goldDesktop.innerHTML = `Nog ${gold} gram beschikbaar!`;
    }

    if (this.silverMobile && this.silverDesktop) {
      this.silverMobile.innerHTML = `Nog ${(silver / 1000).toFixed(0).replace('.', ',')}kg!`;
      this.silverDesktop.innerHTML = `Nog ${(silver / 1000).toFixed(0).replace('.', ',')} kilo beschikbaar!`;
    }
  }

  async getPrices() {
    const gold = JSON.parse(localStorage.getItem('gold'));
    const silver = JSON.parse(localStorage.getItem('silver'));

    this.setLabels(gold.sale_quantity, silver.sale_quantity);
    this.element.classList.add('c-sale--active');
  }
}

export default Sale;
